/**
 * Brand Kit do tenant — GET/PATCH /api/v1/me/brand-kit (DOC 08 § 10.1).
 * Por quê: Carla preenche uma vez; campanhas herdam rodapé ao marcar use_brand_kit.
 */

import { APIClient } from "./api_helper";

const api = new APIClient();

/** Forma usada na UI Conta (campos de formulário). */
export type BrandKit = {
  document: string | null;
  brand_legal_name: string | null;
  brand_address: string | null;
  brand_primary_color: string | null;
  brand_secondary_color: string | null;
  brand_font_family: string | null;
  brand_kit_apply_default: boolean;
  footer_preview_html: string | null;
};

export type BrandKitUpdatePayload = {
  document?: string | null;
  brand_legal_name?: string | null;
  brand_address?: string | null;
  brand_primary_color?: string | null;
  brand_secondary_color?: string | null;
  brand_font_family?: string | null;
  brand_kit_apply_default?: boolean;
};

type ApiBrandKit = {
  document?: string | null;
  legal_name?: string | null;
  address?: string | null;
  primary_color?: string | null;
  secondary_color?: string | null;
  font_family?: string | null;
  apply_default?: boolean;
  footer_preview_html?: string | null;
};

const mapFromApi = (raw: ApiBrandKit | null | undefined): BrandKit => ({
  document: raw?.document ?? null,
  brand_legal_name: raw?.legal_name ?? null,
  brand_address: raw?.address ?? null,
  brand_primary_color: raw?.primary_color ?? null,
  brand_secondary_color: raw?.secondary_color ?? null,
  brand_font_family: raw?.font_family ?? null,
  brand_kit_apply_default: Boolean(raw?.apply_default),
  footer_preview_html: raw?.footer_preview_html ?? null,
});

export async function fetchBrandKit(): Promise<BrandKit> {
  const envelope: any = await api.get("/me/brand-kit");
  if (!envelope?.success) {
    throw new Error(envelope?.error?.message || "brand_kit_fetch_failed");
  }
  return mapFromApi(envelope.data?.brand_kit);
}

export async function updateBrandKit(
  payload: BrandKitUpdatePayload
): Promise<{ data: BrandKit; message?: string }> {
  const envelope: any = await api.update("/me/brand-kit", payload);
  if (!envelope?.success) {
    throw new Error(envelope?.error?.message || "brand_kit_update_failed");
  }
  return {
    data: mapFromApi(envelope.data?.brand_kit),
    message: envelope.message,
  };
}
